import { Link } from "react-router-dom";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";

/**
 * Footer regulatory disclosure block.
 * Extracted from Footer.tsx for maintainability.
 */
export function FooterDisclosures() {
  return (
    <div className="mt-12 pt-8 border-t border-accent/15">
      <div className="max-w-5xl mx-auto text-left text-primary-foreground/70 text-sm leading-relaxed mb-8 space-y-4">
        <p className="font-bold text-white/70 uppercase tracking-wider">
          Important Regulatory Disclosures
        </p>
        <p>
          SRG Consulting PLLC provides business consulting, financial education,
          commercial-capital coordination, professional-team coordination, and
          insurance-based solutions through appropriately licensed
          professionals. SRG does not offer securities or provide
          investment-advisory, legal, tax, or ERISA services. Insurance products
          and availability vary by state and carrier. For complete information,
          visit our{" "}
          <Link
            to="/disclosure-center"
            className="underline hover:text-accent font-medium"
          >
            Disclosure Center
          </Link>
          .
        </p>
        <p>
          SRG Consulting PLLC provides insurance, retirement, wealth protection,
          and financial strategy education for business owners and individuals.
          Services are offered only where properly licensed.{" "}
          <strong>License No. 19177286</strong>.
        </p>
        <p>
          Content on this website and platform is for educational and
          informational purposes only and should not be considered legal, tax,
          ERISA, accounting, securities, or investment advice. Please consult a
          qualified attorney, CPA, plan administrator, or licensed advisor
          before making financial, tax, retirement, rollover, trust, insurance,
          annuity, or business-planning decisions.
        </p>
        <p>
          Insurance and annuity product guarantees are subject to the
          claims-paying ability of the issuing insurance company. Product
          availability, features, benefits, fees, and requirements may vary by
          state and carrier.
        </p>
        <p>
          SRG Consulting PLLC does not guarantee specific financial outcomes.
          All strategies should be reviewed based on your individual goals, risk
          tolerance, business structure, and financial circumstances. Past
          performance is not indicative of future results.
        </p>
        <p>
          By using this website, app, or Exclusive Access portal, you agree to
          our Terms of Use, Privacy Policy, appointment policies, and all
          applicable disclaimers. SRG Consulting PLLC reserves the right to
          modify these terms at any time.
        </p>
        <p>
          <strong>Compensation Disclosure:</strong> SRG Consulting, PLLC may be
          compensated in different ways depending on the product, strategy, or
          consulting service provided. Certain insurance, brokerage, lending, or
          financial products may be commission-based, while consulting and
          advisory services may be flat-fee. Compensation structure varies based
          on client needs and strategies selected. Please review our full
          Regulatory Landscape page for complete details.
        </p>
        <p>
          For license verification, users may check with the appropriate state
          insurance department or regulatory authority. Arizona’s Department of
          Insurance and Financial Institutions provides public license lookup
          resources for insurance professionals and entities. (
          <a
            href="https://difi.az.gov/license-search"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-accent"
          >
            difi.az.gov
          </a>
          ). Business entity verification can be found via the Arizona
          Corporation Commission (
          <HoverCard>
            <HoverCardTrigger asChild>
              <a
                href="https://azcc.gov/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-accent"
              >
                azcc.gov
              </a>
            </HoverCardTrigger>
            <HoverCardContent className="w-80 text-left">
              <div className="space-y-2 text-foreground">
                <h4 className="text-sm font-semibold">
                  Arizona Corporation Commission
                </h4>
                <p className="text-xs text-muted-foreground">
                  The AZCC oversees corporate filings, securities regulation,
                  and ensures the compliance of business entities operating
                  within Arizona.
                </p>
              </div>
            </HoverCardContent>
          </HoverCard>
          ).
        </p>
      </div>
    </div>
  );
}
